import { useMemo } from 'react';
import { FleetDashboardFilters } from 'models/fleet-management/FleetDataFilter';
import { InsightsQuery, toInsightsQuery } from 'store/fleet-management/fleet-management-actions';
import { trendWindow, weekGrid } from 'utils/performance-changes';

/**
 * The page's filters as an insights query, and the same filters over the trend window: a fixed run
 * of weeks back from the window end, whatever window the bar holds.
 */
const useTrendQuery = (filters: FleetDashboardFilters) => {
  const query = useMemo(() => toInsightsQuery(filters), [filters]);
  const trend = useMemo(() => trendWindow(filters.end), [filters.end]);
  const trendQuery = useMemo<InsightsQuery>(() => ({ ...query, ...trend }), [query, trend]);
  const grid = useMemo(() => weekGrid(trend.start), [trend.start]);
  return { query, trendQuery, grid };
};

export default useTrendQuery;
